export const zh = {
  maternity: {
    pregnancy: {
      whatHappens: '怀孕期间，您可能会定期与产科团队预约。您可能需要验血、筛查检查和超声检查。团队会询问您的健康状况、用药、整体感受以及既往怀孕情况。他们会说明建议您参加哪些预约和检查。',
      whyItMayHappen: '产前保健用于了解您的健康和宝宝的发育情况，及早发现可能需要额外关注的问题，并提供信息帮助您参与有关自身护理的决定。',
      whatTeamIsDoing: '团队会随着孕期进展逐步形成对您妊娠情况的整体了解。他们可能会查看测量结果、血液检查、影像检查结果和您的症状，并在需要进一步评估或计划时请产科医生或其他专科人员参与。',
      variationNote: '每个人的孕期护理并不完全相同。预约、检查和影像检查的次数及类型可能会根据您的健康、宝宝的发育、既往妊娠情况以及当地的产科流程而有所不同。',
      nextSteps: [
        { id: 'routine-care', title: '常规产前保健', description: '整个孕期会继续安排预约、筛查和相关信息。', when: '适用于大多数妊娠' },
        { id: 'extra-review', title: '额外复查或专科护理', description: '如有需要，可能会安排额外预约、监测或专科评估。', when: '如果团队发现需要更密切关注的问题' },
        { id: 'prepare', title: '为分娩做准备', when: '随着孕期进展' },
      ],
    },
    'preparing-birth': {
      whatHappens: '随着预产期临近，团队会和您讨论可以在哪里分娩。他们会说明临产的迹象，以及何时联系产科分诊。您可以讨论止痛、引产和宝宝喂养。您也可以询问去医院需要带什么。有些人会进行更详细的分娩计划讨论。',
      whyItMayHappen: '提前计划有助于您了解选择、知道需要联系谁，并为不同情况做好准备。也能让团队讨论哪些因素可能影响最安全的分娩地点或方式。',
      whatTeamIsDoing: '团队会了解您的孕期进展，并和您讨论您的偏好。如有帮助，他们可能会制定额外计划。这可能取决于您的健康状况、宝宝的位置或生长情况、既往分娩经历或其他临床因素。',
      variationNote: '分娩计划表达的是您的偏好，并不是固定流程。分娩过程中情况可能发生变化，团队应在情况改变时向您说明新的选择。并非每个人都需要引产、产科医生复查或麻醉科评估。',
      nextSteps: [
        { id: 'spontaneous-labour', title: '自然临产', when: '如果产程自然开始' },
        { id: 'assessment', title: '正式进入产程前的评估', when: '如果因为宫缩、破水、出血、胎动减少或其他担忧联系产科分诊' },
        { id: 'induction', title: '引产', description: '团队可能会建议通过治疗帮助产程开始，并向您说明方法、时间安排和其他选择。', when: '如果建议引产并且您选择进行' },
        { id: 'planned-birth', title: '计划性剖宫产', description: '有些人会按照计划进行剖宫产，而不是等待自然临产。', when: '如果已与产科团队提前商定' },
      ],
    },
    'labour-birth': {
      whatHappens: '在产程中接受评估时，助产士会询问宫缩情况以及您的感受。她也可能询问是否破水、是否出血以及宝宝的胎动。团队可能会检查您和宝宝、讨论止痛并监测产程进展。分娩可能在助产中心或产房进行。根据情况，可能是阴道分娩、器械助产或剖宫产。',
      whyItMayHappen: '评估和监测有助于团队了解产程进展，以及您和宝宝对产程的耐受情况。如果团队认为有助于安全或产程进展，可能会建议治疗、加强监测或改变分娩方式。',
      whatTeamIsDoing: '团队会在您的偏好和产程中的实际情况之间进行权衡。他们可能会查看胎心、宫缩、检查结果和您的整体状态，并在需要额外支持时请产科医生、麻醉科医生、手术室团队或新生儿团队参与。',
      variationNote: '产程和分娩没有唯一的“正常顺序”。并非每个人都需要持续监护、硬膜外镇痛、器械助产或剖宫产。如果情况发生变化，团队应说明他们担心什么、有哪些选择以及为什么提出某个建议。',
      nextSteps: [
        { id: 'vaginal-birth', title: '阴道分娩', description: '如果情况合适，产程可继续进行，并根据您的选择提供支持和镇痛。', when: '如果产程进展顺利且您和宝宝情况稳定' },
        { id: 'assisted-birth', title: '器械助产', description: '如果需要帮助宝宝经阴道出生，团队可能会讨论产钳或吸引器。', when: '如果团队建议协助阴道分娩' },
        { id: 'caesarean', title: '剖宫产', description: '剖宫产可能是提前计划的，也可能根据产程中的情况临时建议。', when: '如果团队建议剖宫产并且您同意' },
        { id: 'after-birth', title: '宝宝出生后的即时护理', when: '宝宝出生后' },
      ],
    },
    'after-birth': {
      whatHappens: '分娩后，团队会检查您和宝宝。情况允许时，他们会支持您和宝宝一起度过最初几个小时。您可能会获得肌肤接触和喂养支持。您可能留在分娩区域、转到产后病房或回家。有时宝宝需要新生儿团队评估或照护。',
      whyItMayHappen: '这些检查有助于发现产后出血、疼痛、血压变化、喂养困难、体温或呼吸问题等情况，也有助于团队判断您和宝宝在回家前需要哪些支持。',
      whatTeamIsDoing: '团队会支持您的恢复、喂养和亲子互动，完成常规检查并安排安全出院。如果您或宝宝需要额外评估、治疗或新生儿护理，团队会进行安排，并说明出院后的随访和需要联系谁。',
      variationNote: '产后护理因人而异。有些家庭可以较早回家，有些则需要住院更久。宝宝需要新生儿评估并不一定意味着要入住新生儿病房。',
      nextSteps: [
        { id: 'postnatal-ward', title: '产后病房护理', description: '您和宝宝可能会留在病房接受恢复支持、检查和喂养帮助。', when: '如果分娩后需要继续住院' },
        { id: 'neonatal-care', title: '新生儿评估或护理', description: '新生儿医护人员可能会评估宝宝，并根据需要提供进一步监测或治疗。', when: '如果宝宝需要额外评估、监测或治疗' },
        { id: 'home', title: '回家', description: '您应获得有关恢复、喂养、宝宝护理、随访以及何时寻求帮助的信息。', when: '当您和宝宝都准备好离开医院时' },
        { id: 'community-care', title: '社区产后护理', description: '离院后，助产和健康访视支持可能会继续。', when: '出院后，按照当地安排' },
      ],
    },
  },
  'emergency-department': {
    arrival: {
      whatHappens: '您到达后，团队会判断您需要多紧急地接受评估。临床人员可能会询问您为什么来到急诊科。他们可能会检查您的脉搏、血压、呼吸和血氧水平。他们会询问疼痛或其他需要立即处理的问题。',
      whyItMayHappen: '第一次评估有助于识别可能需要紧急治疗的人，并决定每个人最安全的等待或接受护理地点。因此，急诊患者并不总是按照到达先后顺序就诊。',
      whatTeamIsDoing: '团队正在寻找需要立即处理的迹象，记录最初的生命体征，并决定下一步该做什么。',
      variationNote: '根据您看起来的病情严重程度，第一次评估可能非常简短，也可能更详细。有些人会直接进入治疗区或抢救区，其他人则会等待进一步评估。',
      nextSteps: [
        { id: 'assessment', title: '进一步评估和治疗', when: '大多数人在初步评估后' },
        { id: 'urgent-care', title: '更紧急的治疗或监测', when: '如果团队担心您需要立即处理' },
      ],
    },
    'assessment-treatment': {
      whatHappens: '临床人员可能会进一步询问您的健康情况并为您检查。他们会查看您的生命体征。根据症状，您可能需要验血、做心电图或影像检查。在所有结果出来前，治疗可能已经开始。治疗可能包括止痛、补液、药物或吸氧。在等待结果或观察治疗反应时，您可能会再次接受评估。',
      whyItMayHappen: '目标是了解症状可能的原因，先处理不能安全等待的问题，并获得足够信息来决定您是否可以回家，还是需要进一步住院护理。',
      whatTeamIsDoing: '团队会综合您的病史、体格检查、生命体征、检查结果以及对治疗的反应。他们可能会与急诊科高年资医生讨论，或请其他专科团队评估。',
      variationNote: '并非每个人都需要验血、影像检查、监测或相同的治疗。有些结果很快就能出来，有些需要更长时间。等待专科团队评估也可能增加等待时间。',
      nextSteps: [
        { id: 'reassess', title: '再次评估或进一步检查', when: '如果团队需要更多信息，或想观察您对治疗的反应' },
        { id: 'specialty-review', title: '由其他医院专科团队评估', when: '如果可能需要专科意见或治疗' },
        { id: 'decision', title: '决定下一步安排', when: '当团队掌握足够信息可以制定安全计划时' },
      ],
    },
    next: {
      whatHappens: '当团队掌握足够信息后，他们会向您说明计划。您可能可以回家，或回来复诊。您可能需要继续观察，或转到另一个评估区域。有些人会被转院或收入病房。',
      whyItMayHappen: '下一步取决于团队发现了什么、您的感觉如何、治疗是否有效，以及您是否需要在家中无法安全提供的治疗或监测。',
      whatTeamIsDoing: '团队会确保计划安全，安排所需的药物或随访，并在其他团队或病房接手护理时完成必要的信息交接。',
      variationNote: '如果决定住院，从作出决定到转入病房之间可能会因为等待合适床位而延迟。如果您回家，团队应说明接下来该做什么，以及情况变化时何时需要再次寻求帮助。',
      nextSteps: [
        { id: 'home', title: '回家', description: '您可能会获得建议、药物、随访安排或安全提示。', when: '如果团队认为可以安全地在医院外继续护理' },
        { id: 'observation', title: '继续观察或日间/门诊式护理', description: '您可能会继续停留一段时间接受监测、再次评估或计划中的复查。', when: '如果在最终决定前还需要更多时间或进一步评估' },
        { id: 'transfer', title: '转院或专科护理', description: '其他服务可能会接手部分或全部护理。', when: '如果您需要专科团队或其他地点提供护理' },
        { id: 'admission', title: '收入病房', description: '当有合适床位后，病房团队会接收交接并继续您的治疗。', when: '如果您需要持续的住院治疗、监测或支持' },
      ],
    },
  },
};
